import React from 'react';

import AlphaTemplateBannerBlock from './alpha/AlphaTemplateBannerBlock';
import AlphaTemplateBoxesBlock from './alpha/AlphaTemplateBoxesBlock';
import AlphaTemplateHighlightBlock from './alpha/AlphaTemplateHighlightBlock';
import AlphaTemplateMediaBlock from './alpha/AlphaTemplateMediaBlock';
import AlphaTemplateProductsBlock from './alpha/AlphaTemplateProductsBlock';
import AlphaTemplateTextBlock from './alpha/AlphaTemplateTextBlock';

import BetaTemplateDefaultBlock from './beta/BetaTemplateDefaultBlock';

import type { IContentfulLandingPageBlocks } from 'types';
import {
  ContentfulAlphaTemplateBlocks,
  ContentfulBetaTemplateBlocks,
  ContentfulLandingPageType,
  ContentfulSharedTemplateBlocks
} from 'types';

const TEXT_BLOCKS_MAP = {
  [ContentfulLandingPageType.Alpha]: AlphaTemplateTextBlock,
  [ContentfulLandingPageType.Beta]: null,
  [ContentfulLandingPageType.Unknown]: null,
};

const BANNER_BLOCKS_MAP = {
  [ContentfulLandingPageType.Alpha]: AlphaTemplateBannerBlock,
  [ContentfulLandingPageType.Beta]: null,
  [ContentfulLandingPageType.Unknown]: null,
};

const MEDIA_BLOCKS_MAP = {
  [ContentfulLandingPageType.Alpha]: AlphaTemplateMediaBlock,
  [ContentfulLandingPageType.Beta]: null,
  [ContentfulLandingPageType.Unknown]: null,
};

const PRODUCTS_BLOCKS_MAP = {
  [ContentfulLandingPageType.Alpha]: AlphaTemplateProductsBlock,
  [ContentfulLandingPageType.Beta]: null,
  [ContentfulLandingPageType.Unknown]: null,
};

interface Props {
  isMobilePreview: boolean,
  templateType: ContentfulLandingPageType,
  blocks: IContentfulLandingPageBlocks
}

const LandingPageBlocks = (props: Props) => {

  const {
    blocks = [],
    templateType,
    isMobilePreview
  } = props;

  return blocks?.map((block, index) => {
    const { blockType: type, ...rest } = block;
    const sharedProps = {
      isMobilePreview
    };

    switch (type) {

      // Shared Template Blocks

      case ContentfulSharedTemplateBlocks.TextBlock: {
        const Block = TEXT_BLOCKS_MAP[templateType];
        if (Block) {
          return (
            <Block
              key={index}
              {...sharedProps}
              {...rest}
            />
          );
        }
        return null;
      }

      case ContentfulSharedTemplateBlocks.BannerBlock: {
        const Block = BANNER_BLOCKS_MAP[templateType];
        if (Block) {
          return (
            <Block
              key={index}
              {...sharedProps}
              {...rest}
            />
          );
        }
        return null;
      }

      case ContentfulSharedTemplateBlocks.MediaBlock: {
        const Block = MEDIA_BLOCKS_MAP[templateType];
        if (Block) {
          return (
            <Block
              key={index}
              {...sharedProps}
              {...rest}
            />
          );
        }
        return null;
      }

      case ContentfulSharedTemplateBlocks.ProductsBlock: {
        const Block = PRODUCTS_BLOCKS_MAP[templateType];
        if (Block) {
          return (
            <Block
              key={index}
              {...sharedProps}
              {...rest}
            />
          );
        }
        return null;
      }

      // Alpha Template Blocks

      case ContentfulAlphaTemplateBlocks.BoxesBlock: {
        return (
          <AlphaTemplateBoxesBlock
            key={index}
            {...sharedProps}
            {...rest}
          />
        );
      }

      case ContentfulAlphaTemplateBlocks.HighlightBlock: {
        return (
          <AlphaTemplateHighlightBlock
            key={index}
            {...sharedProps}
            {...rest}
          />
        );
      }

      // Beta Template Blocks

      case ContentfulBetaTemplateBlocks.DefaultBlock: {
        return (
          <BetaTemplateDefaultBlock
            key={index}
            {...sharedProps}
            {...rest}
          />
        );
      }

      default: {
        console.error('Unknown block type', type);
        return null;
      }

    }
  });
};

export default React.memo(LandingPageBlocks);
